const autoNgTemplateLoaderTemplate1 = require('./configurationsDatatable.html');

angular.module('shbdeployer.kubernetes').component('kubernetesConfigurationsDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'KubernetesConfigurationsDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    dataset: '<',
    tableKey: '@',
    orderBy: '@',
    refreshCallback: '<',
    removeAction: '<',
  },
});
